import { render, staticRenderFns } from "./ModelTable.vue?vue&type=template&id=0e7284d4"
import script from "./ModelTable.vue?vue&type=script&lang=js"
export * from "./ModelTable.vue?vue&type=script&lang=js"
import style0 from "./ModelTable.vue?vue&type=style&index=0&id=0e7284d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports